<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">

        <div class="card mb-4">
          <div class="card-header pb-0">
            <h4>Diagnosi</h4>
            <button type="button" id="add-btn" class="btn btn-primary" @click="clear" data-bs-toggle="modal" data-bs-target="#formModal">+ Nuovo</button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <custom-table ref="table$" :rows="data" @action="runAction" :columns="[
                {
                    title: 'Esame',
                    type: 'text',
                    data: 'exam.type',
                },
                {
                    title: 'Data',
                    type: 'date',
                    data: 'date',
                },
                {
                    title: 'Data di Validità',
                    type: 'date',
                    data: 'validity_date',
                },
                {
                    title: 'Diagnosi',
                    type: 'text',
                    data: 'diagnosis',
                },
                {
                    title: 'Note',
                    type: 'text',
                    data: 'note',
                },
                {
                    title: 'Fatto',
                    type: 'boolean',
                    data: 'done',
                    on_label: 'SI',
                    off_label: 'NO'
                },
            ]" :actions="[
                {
                    title: 'Modifica',
                    tooltip: 'edit',
                    key: 'edit',
                },
            ]" 
              :pagination="pagination"
              @page-changed="handlePageChange"
              @update-pagination="handlePaginationUpdate"
              @search-changed="handleSearchChange"
            />
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" id="formModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="add" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="formModalBtn">Diagnosi</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="color: black;"></button>
        </div>
        <div class="modal-body">
          <Vueform ref="form$" v-model="horse_exam" sync>
            <HiddenElement name="id" />
            <SelectElement
                name="exam_id"
                :native="false"
                label="Esame"
                rules="required"
                :items="exams"
            />
            <DateElement name="date" label="Data" rules="required"></DateElement>
            <DateElement name="validity_date" label="Data di Validità" rules=""></DateElement>
            <TextareaElement name="diagnosis" label="Diagnosi" rules=""></TextareaElement>
            <TextareaElement name="note" label="Note" rules=""></TextareaElement>
            <ToggleElement name="done">
              Fatto
            </ToggleElement>
            <hr/>
            <MultifileElement
              name="horse_exam_images"
              :object="true"
              url="https://equiup-api.13bit.dev/api/horse-images/get-photo"
              preview-url="https://equiup-api.13bit.dev/api/horse-images/get-thumbnail"
              :upload-temp-endpoint="false"
              label="Upload Foto"
              view="gallery"
              :clickable="true"
              :drop="true"
              storeFile="url"
              :soft-remove="true"
            />
          </Vueform>

        </div>
        <div class="modal-footer">
          <button type="button" id="close" class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
          <button type="button" class="btn btn-primary" :class="{ loading: loading }"  @click="save">Salva</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>

import {horsesExamService} from "@/services/HorsesExamService";
import CustomTable from "@/components/CustomTable";
import { useToast } from "vue-toastification";
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import {useTableData} from "@/composables/useTableData";

const toast = useToast();

export default {
  name: "HorseExams",
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      horse_exam: {},
      exams: [],
    };
  },
  setup(){
    return useTableData(
        horsesExamService.getHorseExams.bind(horsesExamService),
        10
    );
  },
  mounted(){
    this.fetchData({horse_id: this.id});
    horsesExamService.getExams().then(exams => this.exams = exams.map(e => ({value: e.id, label: e.type})));
  },
  computed: {
  },
  components: {
    CustomTable
  },
  created() {
    this.$store.dispatch('updateBreadcrumbs', [
      { title: 'Lista Cavalli', name: 'Horses' },
      { title: 'Cavallo', name: 'Horse', params: { id: this.id } },
      { title: 'Salute', name: 'HorseHealth', params: { id: this.id } },
    ]);
  },
  methods: {
    async runAction({action, row}){
      this.loading = true;
      if(action.key == 'edit'){
        horsesExamService.getHorseExamById(row.id).then((exam) => {
          this.horse_exam = exam;
          this.loading=false;
          const modalElement = document.getElementById('formModal');
          const myModal = new bootstrap.Modal(modalElement);
          myModal.show();
        });
      }
    },
    clear(){
      this.horse_exam = {};
      this.$refs.form$.reset();
    },
    async save(){
      const form = this.$refs.form$;
      form.validate();
      if(this.horse_exam.id) form.data.id = this.horse_exam.id;
      form.data.horse_id = this.id;

      if(form.data.done) form.data.done = 1;
      else form.data.done = 0;

      if (!form.hasErrors) {
        for (const key in form.data) {
          if (form.data[key] === 'null' || form.data[key] === null) {
              delete form.data[key];
          }
        }
        this.loading=true;
        try{
          console.log('form: ' , )
          await horsesExamService.saveHorseExam(form.data);
          toast(this.$t('operation_saved'));
          document.getElementById('close').click();
          this.fetchData({horse_id: this.id});
        }finally{
          this.loading=false;
        }
      }
    },
  },
};
</script>

<style>
.vf-multifile-list img.vf-file-preview-gallery-img[title*=".pdf"]{
}
div[aria-placeholder*=".pdf"] div.vf-file-preview-gallery-image{
  background: url('/pdf.png') no-repeat;
  background-size: contain;
}
</style>
